import type { PageProps } from "react-pdf";
import { FieldKey } from "./interfaces";

// @TODO: make it work properly or remove

export const FIELD_KEYS: FieldKey[] = ["before", "after"];

export const FIELD_TO_UPDATE_KEY: Record<
    FieldKey,
    "text_before" | "text_after"
> = {
    before: "text_before",
    after: "text_after",
};

export const MARKERS: Record<FieldKey, { start: string; end: string }> = {
    before: { start: "[[TB]]", end: "[[/TB]]" },
    after: { start: "[[TA]]", end: "[[/TA]]" },
};

export const FIELD_SELECTOR = (field: FieldKey) =>
    `[data-budget-field="${field}"]`;

const ESCAPE: Record<string, string> = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
};

const escapeHtml = (value: string) => value.replace(/[&<>]/g, (c) => ESCAPE[c]);

const wrap = (field: FieldKey, text: string) =>
    `<span class="mm-inline-source" data-budget-field="${field}">${escapeHtml(
        text,
    )}</span>`;

export const createFieldTextRenderer = (): NonNullable<
    PageProps["customTextRenderer"]
> => {
    let inField: FieldKey | null = null;

    const findEarliestStart = (rest: string) => {
        let best: { field: FieldKey; index: number } | null = null;

        for (const field of FIELD_KEYS) {
            const index = rest.indexOf(MARKERS[field].start);

            if (index !== -1 && (best === null || index < best.index)) {
                best = { field, index };
            }
        }

        return best;
    };

    return ({ str, itemIndex }) => {
        if (itemIndex === 0) {
            inField = null;
        }

        let out = "";
        let rest = str;

        while (rest.length > 0) {
            if (inField) {
                const end = MARKERS[inField].end;
                const index = rest.indexOf(end);

                if (index === -1) {
                    out += wrap(inField, rest);
                    rest = "";
                } else {
                    out += wrap(inField, rest.slice(0, index));
                    rest = rest.slice(index + end.length);
                    inField = null;
                }
            } else {
                const start = findEarliestStart(rest);

                if (!start) {
                    out += escapeHtml(rest);
                    rest = "";
                } else {
                    out += escapeHtml(rest.slice(0, start.index));
                    rest = rest.slice(
                        start.index + MARKERS[start.field].start.length,
                    );
                    inField = start.field;
                }
            }
        }

        return out;
    };
};
